import _ from "lodash";

export default function translate(key) {
	if(process.env.NODE_ENV === 'test'){
		return 'Test-Text';
	}

	if(process.env.NODE_ENV === 'development') {
		return 'Translate Label';
	}

	if(_.has(window.nezzoagenda_translation, key)){
		return _.get(window.nezzoagenda_translation, key)
	}
	else{
		throw new Error('Invalid key ' + key);
	}
}


// WEBPACK FOOTER //
// ./React/src/service/translation.js